<template>
  <div :style="{'background-color':'#F7F7F7'}">
<!--    <van-nav-bar title="数据中心" id="topbar"/>-->

    <div class="content">
      <div class="monitor-section">
        <div class="time-range-buttons">
          <van-button @click="showDatePicker('start')" size="small" class="time-button">
            {{ startTime || '开始时间' }}
          </van-button>
          <span class="time-separator"> ~ </span>
          <van-button @click="showDatePicker('end')" size="small" class="time-button">
            {{ endTime || '结束时间' }}
          </van-button>
          <van-button type="primary" @click="filterData" size="small" class="filter-button">
            查询
          </van-button>
          <van-button type="info" @click="exportExcel" size="small" :loading="exportLoading"
                      color="linear-gradient(135deg, #1B75F6 0%, #4A90E2 100%)" class="filter-button">
            导出
          </van-button>
        </div>
      </div>
      <div class="monitor-section">
          <van-tabs v-model:active="dataType" @change="handleChangeTabs">
            <van-tab v-for="item in dataDict" :title="item.title" :name="item.dataType">
              <!-- 数据列表 -->
              <div class="data-container">
                <div class="data-header">
                  <div class="header-item">时间</div>
                  <div class="header-item">温度℃</div>
                  <div class="header-item">流量L/S</div>
                  <div class="header-item">余氯mg/L</div>
                  <div class="header-item">pH</div>
                </div>

                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                  <van-list v-model="loading" :finished="finished"
                            :finished-text="displayData.length === 0 ? '' : '没有更多数据了'"
                            @load="loadMore" :immediate-check="false"
                            class="data-list" :style="{ height:  'calc(90vh - 130px)' }">

                    <div v-for="(item, index) in displayData" :key="index" class="data-item">
                      <div class="data-cell">{{ item.monitorTime }}</div>
                      <div class="data-cell">{{ item.waterTemperature !== null && item.waterTemperature !== undefined ? item.waterTemperature : '/' }}</div>
                      <div class="data-cell">{{ item.flow !== null && item.flow !== undefined ? item.flow : '/' }}</div>
                      <div class="data-cell" :class="{ 'alarm': (item.chloride < 2.0 || item.chloride > 8.0) && item.chloride !== null && item.chloride !== undefined }">
                        {{ item.chloride !== null && item.chloride !== undefined ? item.chloride : '/' }}
                        <span v-if="(item.chloride < 2.0 || item.chloride > 8.0) && item.chloride !== null && item.chloride !== undefined">(超标)</span>
                      </div>
                      <div class="data-cell" :class="{ 'alarm': (item.ph < 6.0 || item.ph > 9.0) && item.ph !== null && item.ph !== undefined }">
                        {{ item.ph !== null && item.ph !== undefined ? item.ph : '/' }}
                        <span v-if="(item.ph < 6.0 || item.ph > 9.0) && item.ph !== null && item.ph !== undefined">(超标)</span>
                      </div>
                    </div>

                    <!-- 无数据提示 -->
                    <div v-if="displayData.length === 0 && finished" class="empty-data">
                      <div class="empty-icon">
                        <van-icon name="success" size="48" color="#52C41A" />
                      </div>
                      <div class="empty-text">暂无数据</div>
                      <div class="empty-subtext">请调整查询条件后重试</div>
                    </div>
                  </van-list>
                </van-pull-refresh>
              </div>
            </van-tab>
          </van-tabs>
      </div>
    </div>

    <!-- 日期选择器 -->
    <van-popup v-model="showDatePickerFlag" position="bottom">
      <van-datetime-picker
        type="date"
        v-model="currentDate"
        @confirm="confirmDate"
        @cancel="showDatePickerFlag = false"
        title="选择日期"
      />
    </van-popup>

    <!--   底部定义组件   -->
    <tabular :active="2"/>
  </div>
</template>

<script>
  import $ from '@/fly'
  import Tabular from '@/components/tabbar.vue';
  import request from '@/utils/request'
  export default {
    name: 'historyInfo',
    components: { Tabular },
    data () {
      return {
        loading: false,
        pageNum: 1,
        pageSize: 20,
        startTime: '',
        endTime: '',
        displayData: [],
        finished: false,
        // 下拉刷新相关
        refreshing: false,
        // 日期选择相关
        showDatePickerFlag: false,
        currentDatePicker: '',
        currentDate: new Date(),
        dataDict: [
          { title:'分钟数据', dataType: 'minute'},
          { title:'小时数据', dataType: 'hour'},
          { title:'日数据', dataType: 'day'},
        ],
        dataType:'minute',
        exportLoading: false
      }
    },
    computed: {
    },
    methods: {
      exportExcel() {
        if (this.exportLoading) return
        this.exportLoading = true
        request.export('mobile/history/exportData', {
          startTime: this.startTime+ ' 00:00:00',
          endTime: this.endTime+ ' 23:59:59'
        },'监测数据（'+this.startTime+' 至 '+this.endTime+'）.xlsx').finally(() => {
          this.exportLoading = false
        })
      },
      // 标签切换
      handleChangeTabs() {
        this.filterData()
      },
      // 初始化数据
      initData () {
        this.setDateRange()
        this.getHistoryData()
      },
      // 获取历史数据
      getHistoryData() {
        this.loading = true;
        $.get('mobile/history/historyData', {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          startTime: this.startTime,
          endTime: this.endTime,
          dataType:this.dataType
        }).then(res => {
          const data = res.data || [];
          if (data.length === 0) {
            this.finished = true;
          } else {
            if (this.pageNum === 1) {
              this.displayData = [...data];
            } else {
              this.displayData = [...this.displayData, ...data];
            }
            this.finished = data.length < this.pageSize;
          }
        }).catch(() => {
          this.finished = true;
        }).finally(() => {
          this.loading = false;
          this.refreshing = false;
          if (!this.finished) {
            this.pageNum++;
          }
        })
      },
      // 设置默认时间
      setDateRange() {
        // 默认近7天数据，格式为yyyy-mm-dd
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - 7);

        // 格式化日期为yyyy-mm-dd格式
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        this.startTime = formatDate(startDate);
        this.endTime = formatDate(endDate);
      },
      // 显示日期选择器
      showDatePicker(type) {
        this.currentDatePicker = type;
        this.showDatePickerFlag = true;
      },
      // 确认日期选择
      confirmDate(value) {
        // 格式化日期为yyyy-mm-dd格式
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const day = String(value.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        if (this.currentDatePicker === 'start') {
          this.startTime = formattedDate;
        } else {
          // 检查结束时间是否大于开始时间
          if (this.startTime && new Date(formattedDate) < new Date(this.startTime)) {
            this.$dialog.alert({
              title: '提示',
              message: '结束时间不能小于开始时间'
            });
            return;
          }
          this.endTime = formattedDate;
        }
        this.showDatePickerFlag = false;
      },
      // 过滤数据
      filterData() {
        this.pageNum = 1;
        this.finished = false;
        this.displayData = [];
        this.getHistoryData()
      },
      // 加载更多数据
      loadMore() {
        if (!this.finished) {
          this.getHistoryData()
        }
      },
      // 下拉刷新
      onRefresh() {
        this.pageNum = 1;
        this.finished = false;
        this.displayData = [];
        this.getHistoryData()
      }
    },
    mounted () {
      this.initData();
    }
  }
</script>

<style lang="less" scoped>

  .content {
    height: calc(98vh - 50px);
  }

  .monitor-section {
    background: white;
    border-radius: 10px;
    padding: 16px;
    margin-bottom: 20px;

    .section-title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 20px;
      color: #333;
      display: flex;
      align-items: center;
    }
  }

  .time-range-buttons {
    display: flex;
    align-items: center;
    gap: 8px;

    .time-button {
      width: 27%;
      height: 75px;
      line-height: 75px;
      font-size: 28px;
      padding: 0 1px;
      border-radius: 20px;
    }

    .time-separator {
      font-size: 28px;
      color: #666;
    }

    .filter-button {
      font-size: 28px;
      width: 20%;
      height: 75px;
      line-height: 75px;
      padding: 0 1px;
      border-radius: 20px;
    }
  }

  /deep/ .van-picker-column .van-ellipsis {
    color: #1b1a1a !important;
  }

  .query-container {
    background-color: #FFFFFF;
    padding: 15px 20px;
    margin-bottom: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .date-range {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;

      .date-item {
        display: flex;
        align-items: center;

        .date-label {
          font-size: 22px;
          color: #333333;
          margin-right: 10px;
        }

        .date-picker-btn {
          font-size: 22px;
          padding: 8px 16px;
          border-radius: 4px;
        }
      }
    }

    .query-btn {
      width: 100%;
      font-size: 22px;
      padding: 10px 0;
      border-radius: 4px;
    }
  }

  .data-container {
    background-color: #efefef;
    border-radius: 8px;
    overflow: hidden;
    border: #c3c3c3 1px solid;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);

    .data-header {
      display: flex;
      background-color: #d5d5d5;
      padding: 15px 0;
      font-size: 25px;
      font-weight: bold;
      color: #333333;
      border-bottom: 1px solid #E8E8E8;

      .header-item {
        flex: 1;
        text-align: center;
      }
    }

    .data-list {
      overflow-y: auto;

      .data-item {
        display: flex;
        padding: 15px 5px;
        border-bottom: 1px solid #cfcfcf;
        font-size: 22px;
        color: #333333;

        .data-cell {
          flex: 1;
          text-align: center;
        }

        .alarm {
          color: #FF4D4F;
        }
      }
    }

    .empty-data {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40% 0;
      text-align: center;

      .empty-icon {
        font-size: 60px;
        margin-bottom: 20px;
      }

      .empty-text {
        font-size: 30px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
      }

      .empty-subtext {
        font-size: 25px;
        color: #999;
      }
    }
  }
</style>
